import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL, API_URL_V4, APP_TOKEN } from 'src/environments/environment.local';

@Injectable()
export class AppTokenInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes(API_URL) || request.url.includes(API_URL_V4)) {
      if (request.url.includes('getV2')) {
        request = request.clone({
          setParams: {
            appToken:
              '5cphz6MXH1Uzr8zDsJ6uVSYS9aOzMXXDio0dclN6QwFDVlZc7h84qDZNG2ttdAeLvhxlc7jCNGe454PmNiDV8cdruQTHW388mCXgexzC7UoydgkWsLMMmDun',
          },
        });
      } else {
        request = request.clone({
          setParams: {
            appToken: APP_TOKEN,
          },
        });
      }
    }
    return next.handle(request);
  }
}
